import styled from 'styled-components'
import { theme, media } from '../../styles/_variables'

export const Instruction = styled.p`
  font-size: ${theme.fonts.size.small};
`

export const ChangePasswordWrapper = styled.div`
  ${media.tablet`
    > div {
      &:nth-child(3),
      &:nth-child(2) {
        div {
          width: 100%;
        }
      }
    }
  `}
`

export default Instruction



// WEBPACK FOOTER //
// ./src/pages/change-password/styled.js